export default __webpack_public_path__ + "static/media/one.ad1163eb.jpg";